import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { ALL_SCREENS } = require('../Constants/configscreens.constants');
const { createRequest } = require('../../api/client');

export const getAllScreens = () => async (dispatch) => {
    const options = {
        url: `${Variable.backendUrl}/login-screen/getAllData`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: {}
    };
    try {
        const data = await createRequest(options);
        const screens = data.message;
        const names = screens.map((screen) => screen.name);
        dispatch({
            type: ALL_SCREENS,
            data: { screens, names }
        });
    } catch (err) {
        handleExcception(err);
    }
};

export const getAllScreensList = async () => {
    const options = {
        url: `${Variable.backendUrl}/login-screen/getAllData`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: {}
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};
